import { InjectionToken } from '@angular/core';

export const OUTLOOK_SYNC_API_URL = new InjectionToken<string>(
  'outlookSyncApiUrl',
);
export const OUTLOOK_SYNC_SUBSCRIPTION_KEY = new InjectionToken<string>(
  'outlookSyncSubscriptionKey',
);
export const APP_STORE_OAUTH_URL = new InjectionToken<string>(
  'appStoreOAuthUrl',
);
export const APP_STORE_CONFIGURATION_URL = new InjectionToken<string>(
  'appStoreConfigurationUrl',
);
